module.exports = __webpack_public_path__ + "static/Stellenplan im Excel Start-0556963244e76d355cf679782f21ad9b.jpg";